(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ah-wf50-popup"]) return;
  try {
    
  if (!customElements.get('ah-white-friday')) {
    customElements.define('ah-white-friday', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.launch = this.querySelector('.ah-wf-launch');
        if (!this.dialog || !this.dialog.showModal) return;
        this.storageKey = 'ah_wf50_20261102';
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
        this.write = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
        this.open = () => {
          if (!this.dialog.open) {
            this.returnFocus = document.activeElement;
            this.dialog.showModal();
          }
        };
        this.close = () => this.dialog.close();
        this.launch.hidden = false;
        this.launch.addEventListener('click', this.open, { signal });
        this.querySelectorAll('[data-wf-close]').forEach(button => button.addEventListener('click', this.close, { signal }));
        this.dialog.addEventListener('close', () => {
          this.write(this.storageKey, 'dismissed');
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        }, { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
        }, { signal });
        this.querySelector('form')?.addEventListener('submit', () => {
          this.write(this.storageKey + '_pending', String(Date.now()));
          const submit = this.querySelector('[data-wf-submit]');
          if (submit) { submit.disabled = true; submit.setAttribute('aria-busy', 'true'); }
        }, { signal });
        this.querySelector('[data-wf-copy]')?.addEventListener('click', async event => {
          const button = event.currentTarget;
          try {
            await navigator.clipboard.writeText(button.dataset.code);
            button.textContent = button.dataset.copied;
          } catch {
            const range = document.createRange();
            range.selectNodeContents(this.querySelector('.ah-wf-code'));
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
          }
        }, { signal });
        const pending = Number(read(this.storageKey + '_pending'));
        const recentSubmission = pending > 0 && Date.now() - pending < 600000;
        if (this.querySelector('[data-wf-result]') && recentSubmission) {
          this.write(this.storageKey + '_pending', '');
          this.open();
          return;
        }
        if (this.dataset.designMode === 'true' || read(this.storageKey)) return;
        let interacted = false;
        let elapsed = false;
        const attempt = () => {
          if (!interacted || !elapsed || document.hidden || this.dialog.open || read(this.storageKey)) return;
          if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
          const busy = Array.from(document.querySelectorAll('dialog[open], [role="dialog"], [aria-modal="true"], cart-drawer')).some(element => {
            if (element === this.dialog) return false;
            const box = element.getBoundingClientRect();
            return box.width > 0 && box.height > 0 && box.bottom > 0 && box.right > 0 && box.top < innerHeight && box.left < innerWidth && getComputedStyle(element).visibility !== 'hidden';
          });
          if (busy) return;
          if (/\/(cart|checkout|account)(\/|$)/.test(location.pathname)) return;
          this.open();
          this.write(this.storageKey, 'shown');
        };
        const interaction = () => { interacted = true; attempt(); };
        ['pointerdown', 'keydown', 'scroll'].forEach(type => document.addEventListener(type, interaction, { passive: true, signal }));
        this.timer = setTimeout(() => { elapsed = true; attempt(); }, Math.max(3, Number(this.dataset.delay) || 4) * 1000);
      }
      disconnectedCallback() { this.abort?.abort(); clearTimeout(this.timer); this.ready = false; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
